import { render, staticRenderFns } from "./HomePromo.vue?vue&type=template&id=342f7c24&scoped=true&"
import script from "./HomePromo.vue?vue&type=script&lang=js&"
export * from "./HomePromo.vue?vue&type=script&lang=js&"
import style0 from "./HomePromo.vue?vue&type=style&index=0&id=342f7c24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342f7c24",
  null
  
)

export default component.exports